import PropTypes from 'prop-types';
import { OrganizationProptypes } from 'shared/propTypes/organizationType';
import SettingsLayout from 'components/SettingsTabLayout';
import ClientSettings from './ClientSettings';
import logger from 'utils/logger';

const propTypes = {
  organizationInfo: PropTypes.shape(OrganizationProptypes),
};

const log = logger.createLogger('ClientManagementTab');

const ClientManagementTab = ({ organizationInfo }) => {
  const quotaSrcOrgs = [...organizationInfo.contractsAsSrcOrg].sort((a, b) =>
    a.dstOrg.name < b.dstOrg.name ? -1 : 1
  );

  const tabs = quotaSrcOrgs.map((quotaOrg) => ({
    label: quotaOrg.dstOrg.name,
    component: <ClientSettings quotaSrcOrg={quotaOrg} />,
  }));

  return (
    <SettingsLayout title="" tabs={tabs} settingsType="client-management" />
  );
};

ClientManagementTab.propTypes = propTypes;

export default ClientManagementTab;
